module.exports = __webpack_public_path__ + "img/list_Character_sq_18.65b63b30.jpeg";